<script>
import { Bar } from "vue-chartjs";

export default {
  name: "BarStatisticChart",
  extends: Bar,
  props: {
    height: {
      type: Number,
      default: 250,
    },
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: "#FFFFFF",
            fontSize: 14,
            fontStyle: "bold",
            fontFamily: "Arial",
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "#FFFFFF",
                fontSize: 12,
                fontFamily: "Arial",
              },
              gridLines: {
                color: "rgba(255,255,255,0.1)",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "#FFFFFF",
                fontSize: 12,
                fontFamily: "Arial",
                beginAtZero: true,
              },
              gridLines: {
                color: "rgba(255,255,255,0.1)",
              },
            },
          ],
        },
      }),
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      },
    },
  },
};
</script>

<style></style>
